import React from 'react';

import PropTypes from 'prop-types';

import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme from '@adsk/alloy-react-theme';

const TableFooter = ({
  loading,
  error,
  onRetry,
  loadingMoreText,
  errorText,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  let footer = null;
  if (loading) {
    footer = (
      <>
        <ProgressRing size={ProgressRing.SIZES.SMALL} />
        <Text typography="bodySmall" color="charcoal700" marginLeft="13px">
          {loadingMoreText || T.translate('LOADING_MORE')}
        </Text>
      </>
    );
  } else if (error) {
    footer = (
      <>
        <AlertWarningIcon
          style={{
            color: theme.colors.charcoal700,
          }}
        />
        <Text
          typography="bodySmall"
          color="charcoal700"
          marginLeft="12px"
          marginRight="8px"
        >
          {errorText || T.translate('ERROR_LOADING_ALL_RESULTS')}
        </Text>
        <LinkButton onClick={onRetry} style={theme.typography.bodySmall}>
          {T.translate('TRY_AGAIN')}
        </LinkButton>
      </>
    );
  }

  if (!footer) return null;

  return (
    <Flex alignItems="center" paddingLeft="50px" height="48px" flex="none">
      {footer}
    </Flex>
  );
};

TableFooter.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onRetry: PropTypes.func,
  loadingMoreText: PropTypes.string,
  errorText: PropTypes.string,
};

export default TableFooter;
